module.exports = __webpack_public_path__ + "static/certificate-a2d0feb65f5e56f39fb4129755cb18f1.png";